import axios from "axios";
import { NavigateFunction } from "react-router";
import { AppDispatch } from ".";
import { unAuthenticate } from "./questionnaire/questionnaireSlice";

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  config.baseURL = process.env.REACT_APP_WEB_SERVICE_BASE_URL
  config.headers['Accept'] = '*/*';
  config.withCredentials = true;
  console.log('AXIOS REQUEST::  ', config);
  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
export const setupAxiosResponseInterceptors = (
  dispatch: AppDispatch, navigate: NavigateFunction) => {
  // Add a response interceptor
  axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    console.log('AXIOS RESPONSE:: ', response);

    return response;
  }, function (error) {
    console.log('AXIOS ERROR:: ', error.response.status);
    if (error.response.status === 401) {
      // dispatch(notify('Session just ended. Kindly enter security code again', 'error'))
      dispatch(unAuthenticate())
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  });
}


export default axios;